module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('life-search-bar', {
    staticClass: "search",
    attrs: {
      "value": _vm.$route.params.search
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "title-block"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Search results for \"" + _vm._s(_vm.$route.params.search) + "\"")])]), _vm._v(" "), _c('div', {
    staticClass: "sortBy"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "chevron-down"
    }
  }), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "underlineShow": false
    },
    on: {
      "change": _vm.filterResults
    },
    model: {
      value: (_vm.sortBy),
      callback: function($$v) {
        _vm.sortBy = $$v
      },
      expression: "sortBy"
    }
  }, [_c('mu-menu-item', {
    staticClass: "sortByItems",
    attrs: {
      "value": 1,
      "title": "Most favourites"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    staticClass: "sortByItems",
    attrs: {
      "value": 2,
      "title": "Newest first"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    attrs: {
      "id": "lifeSearchArticles"
    }
  }, [_vm._l((_vm.chunkedItems), function(chunks, index) {
    return _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      staticStyle: {
        "margin-top": "20px",
        "margin-bottom": "20px"
      },
      attrs: {
        "gutter": 16,
        "align": "flex-start"
      }
    }, _vm._l((chunks), function(post, index) {
      return _c('mu-flexbox-item', {
        key: 'post-' + index,
        staticClass: "post"
      }, [_c('div', {
        staticClass: "search-card"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'LifeStyleArticle',
            params: {
              permalink: post.post_slug
            }
          }
        }
      }, [_c('figure', {
        staticClass: "img"
      }, [_c('img', {
        attrs: {
          "src": post.post_image
        }
      })]), _vm._v(" "), _c('h4', {
        domProps: {
          "textContent": _vm._s(post.post_title)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('div', {
        staticClass: "date"
      }, [_c('mu-icon', {
        attrs: {
          "value": "watch_later",
          "color": "#5b617c"
        }
      }), _vm._v(" "), _c('time', {
        attrs: {
          "datetime": "post.post_date"
        },
        domProps: {
          "textContent": _vm._s(_vm.moment(post.post_date).fromNow())
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "favourites"
      }, [_c('mu-icon', {
        attrs: {
          "value": "favorite",
          "color": "#d83e38"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(post.post_favourites)
        }
      })], 1)])])], 1)])
    }), 1)
  }), _vm._v(" "), (!_vm.chunkedItems.length) ? _c('p', [_vm._v("Sorry, could not not find any articles based on your search")]) : _vm._e(), _vm._v(" "), (_vm.loadingMore) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [(_vm.loadMore) ? _c('mu-flat-button', {
    staticClass: "load-more",
    attrs: {
      "label": "Load more"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateResults()
      }
    }
  }) : _vm._e()], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.isAppending) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-493b024e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LifeStyle/Search/LifeSearch.vue
// module id = 3709
// module chunks = 1